import React, { useMemo } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Header from '../../../components/layout/Header';
import AdvancedSearch from '../../../components/leads/AdvancedSearch';
import LeadTable from '../../../components/leads/LeadTable';
import useLeads from '../../../hooks/useLeads';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../../components/common/Common';

const SourceLeads = () => {
  const navigate = useNavigate();
  const { srcId } = useParams();
  const location = useLocation();
  const sourceName = location.state?.sourceName || 'Source';

  const baseFilters = useMemo(() => ({ source: srcId }), [srcId]);
  const { leads, loading, pagination, filters, setFilters, onSearch, onPageChange, refresh, exportAll } = useLeads(baseFilters);

  return (
    <div>
      <Header
        title={`${sourceName} Leads`}
        subtitle={`${pagination.total || 0} total`}
        actions={<Button variant="outline" icon={ArrowLeft} onClick={() => navigate(-1)}>Back</Button>}
      />
      <div className="page">
        <AdvancedSearch filters={filters} setFilters={setFilters} onSearch={onSearch} />
        <LeadTable
          leads={leads}
          loading={loading}
          pagination={pagination}
          onPageChange={onPageChange}
          onRefresh={refresh}
          onExportAll={exportAll}
          showLeadType
          emptyMessage={`No leads found for ${sourceName}`}
        />
      </div>
    </div>
  );
};

export default SourceLeads;
